<template>
    <div class="container">
        <div class="topBlock common-space-between">
            <div>
               <div class="companyName">{{factoryInfo.companyName}}</div>
               <div class="addrerss">{{factoryInfo.address}}</div>
            </div>
            <div>
                <div class="httpAddress">{{factoryInfo.domainName}}</div>
                <div class="common-space-between warpnMAR">
                    <div class="span">站点ID:{{factoryInfo.id}}</div>
                    <div class="span">
                      <i class="el-icon-s-custom"></i>   
                      <span>{{factoryInfo.userName}}</span>
                    </div>
                    <div class="span">
                      <i class="el-icon-phone"></i>   
                      <span>{{factoryInfo.phone}}</span>
                    </div>
                </div>
            </div>   
        </div>
        <div class="common-items-center common-space-between">
          <div class="common-items-center">
            <div class="common-items-center">
              <div style="width:105px;font-size:15px;">产品名称：</div> 
              <el-input :size="this.$store.state.tableSize" v-model="factoryName" placeholder="请输入产品名称" style="margin-right:10px"></el-input>
            </div>
             <el-button size="small" type="primary" icon="el-icon-search" @click="serachBtn">查询</el-button>
             <el-button size="small" type="danger"  icon="el-icon-refresh-left" @click="resetBtn">重置</el-button>
          </div>
          <div>
            <el-button size="small" type="primary" icon="el-icon-download"   @click="serachBtn">导出</el-button>
            <el-button size="small" type="danger"  icon="el-icon-arrow-left" @click="goBackBTN">返回</el-button>
          </div>
       </div>
        <div class="warp-table">
            <el-table ref="giftTable" :data="tableData" :empty-text="this.$store.state.tableEmpty" :size="this.$store.state.inputSize" style="width: 100%"  row-key="id"  :height="this.$store.state.windowHeight-375" lazy   @selection-change="checkSelectBtn">
                <el-table-column  align="center" header-align="center" :show-overflow-tooltip="true" type="selection"    width="55"></el-table-column>
                <el-table-column  align="center" header-align="center" :show-overflow-tooltip="true" prop="id"           label="产品图片"  width="80">
                   <template slot-scope="scope">
                      <el-image  style="width:35px;height:35px;border-radius:4px;"  :src="scope.row.imageUrl"  :preview-src-list="[scope.row.imageUrl]">
                        <div slot="placeholder" class="image-slot">
                          <span class="dot">
                            <i class="el-icon-loading"></i>
                          </span>
                        </div>
                      </el-image>  
                   </template>
                </el-table-column>
                <el-table-column  align="left" header-align="left" :show-overflow-tooltip="true" prop="name"         label="产品名称" width="250" >
                  <template slot-scope="scope">
                    <span class="lookName" @click="openProduct(scope.row)">{{scope.row.name}}</span> 
                  </template>  
                </el-table-column>
                <el-table-column  align="left" header-align="left"   :show-overflow-tooltip="true" prop="deviceTypeName"    label="设备分类" width="250"></el-table-column>
                <!-- <el-table-column  align="left" header-align="left"   :show-overflow-tooltip="true" prop="protocolName"      label="协议分类" width="250"></el-table-column> -->
                <el-table-column  align="left" header-align="left"   :show-overflow-tooltip="true" prop="protocolName"      label="协议名称" width="250"></el-table-column>
                <el-table-column  align="left" header-align="left"   :show-overflow-tooltip="true" prop="factoryName"      label="协议所属公司" width="250"></el-table-column>
                <el-table-column  align="left" header-align="left"   :show-overflow-tooltip="true" prop="protocolVersion"   label="版本"        width="200"></el-table-column>
                <el-table-column  align="left"   header-align="left" :show-overflow-tooltip="true" prop="updateTime"      label="更新时间"     width="200">
                  <template slot-scope="scope">
                         <span v-if="!scope.row.modifyTime">{{scope.row.createTime}}</span>
                         <span v-else>{{scope.row.modifyTime}}</span>
                     </template>
                </el-table-column>
                <el-table-column  align="center" header-align="center" :show-overflow-tooltip="true" prop="address"     label="状态"  >
                    <template slot-scope="scope">
                        <span v-if="scope.row.userStatus*1==1" style="color:#409EFF">正常</span>
                        <span v-else style="color:#909399;">禁用</span>
                    </template>
                    </el-table-column>
            </el-table>
            <Paging @getPage="getPage" :total="total" :pageNo="current" :size="size"/>
        </div>
        <LookBlock ref="lookBlock"></LookBlock> 
    </div>
  </template>
  
  <script>
  import { scroll } from '@/components/component-mixin/block-scroll'
  import {userApi,operate} from '@/utils/config'
  import {postFun,deleteFun,putFun,getFun} from '@/utils/httpFun'
  import {getParms} from '@/utils/util'
  import LookBlock from './block-info.vue'
  export default {
    name: 'index',
    mixins: [scroll],
    components:{
      LookBlock
    },
    data:()=>({  
      queueID:0,
      inputName:"",
      factoryInfo:{},
      factoryId:0,
      tableData: [],
      factoryName:null,
      current:1,
      size:10,
      total:10,   
    }),
    created(){
      this.size = this.$store.state.pageSize
      this.factoryId = getParms().factoryId
      this.getDatas()
      this.getFactoryInfo()
    },
    methods:{
  
      //获取所有的数据
      async getDatas(){
        let parms = {
            param:{
              factoryId:this.factoryId,
              name:this.factoryName
            },
            
            current:this.current,
            size:this.size
          }
          await postFun(operate.PRODUCTCOMMY,parms,res=>{
               this.tableData = res.data.records 
               this.total = res.data.total
               this.size = res.data.size
               this.current = res.data.current
          })
      },
      
      //获取工厂的信息
      getFactoryInfo(){
        getFun(operate.PRODUCTFACTORYINFO+this.factoryId,{},res=>{
           console.log("共享",res.data)
           this.factoryInfo = res.data
        })
      },
      

      //获取输入框/选择框的值
      getVal(ev){
         if(ev.key=="keyWord"){
             this.formData.keyWord = ev.val
         }
         if(ev.key=="status"){
             this.formData.status = ev.indexNo
         }
      },
      
      //查询
      serachBtn(){
         this.getDatas()
      },
      
      //重置
      resetBtn(){
         this.factoryName = null
         this.current = 1
         this.getDatas()
      },
      
     //多选
      checkSelectBtn(ev){
         
      },
       
      //查看产品名称的详情
       openProduct(ev){
        getFun(operate.PRODUCTDETAIL+"/"+ev.id,{},res=>{
            let data = res.data
            let parms = {
                imgList:res.data.resources,
                prdocutName:data.name,
                describes:data.describes,
                list:[
                  {title:"产品分类",val:data.deviceTypeName},
                  {title:"设备分类",val:data.typeName},
                  {title:"产品型号",val:data.model},
                  {title:"企业名称",val:data.factoryName},
                  {title:"协议名称",val:data.protocolName},
                  {title:"更新时间",val:!data.updateTime ? data.createTime : data.updateTime},
                  {title:"协议公司",val:data.factoryName},
                  {title:"最近操作人",val:data.operator},
                  {title:"版本",val:data.protocolVersion}
                ]
              }
            this.$refs.lookBlock.openBtn(parms)
          })
       }, 
       //返回上一页
       goBackBTN(){
          this.$router.replace({
            path:"Message",
            query:{}
          })
       },

      //分页
      getPage(ev){
          this.size = ev.pageSize
          this.current = ev.pageNo 
          this.getDatas()
      }
    }
  }
  </script>
  <style lang="scss" scoped>
      .container{
          padding:15px;
          box-sizing: border-box;
      }
      .topBlock{
        height: 80px;
        width: 100%;
        border-radius:3px;
        background: linear-gradient(135deg, rgba(0, 153, 255, 0.5) 0%, rgba(0, 153, 255, 0.6) 23%, rgba(0, 204, 255, 0.7) 53%, rgba(0, 153, 255, 0.8) 100%, rgba(0, 153, 255, 0.9) 100%);
        margin-bottom: 15px;
        padding: 10px 15px;
        box-sizing: border-box;
        .companyName{
           font-size:26px;
           color: white;
           
        }
        .addrerss{
           font-size: 16px;
           color: white;
           padding-top:4px;
        }
        .httpAddress{
           font-size: 18px;
           color: white;
           text-align: right;
        }
        .warpnMAR{
           margin-top:12px;
           color: white;
           font-size: 16px;
           .span{
              margin-left: 18px;
           }
           i{
            font-size: 18px;
            margin-right: 5px;
           }
        }
      }
      .warp-table{
          margin-top: 15px;
          width: 100%;
      }
      .lookName{
          color: #458EFF;
          cursor: pointer;
      }
  </style>
  